import React from 'react'

import e2eClasses from '../../../helpers/automation'
import Message from '../../message'
import { FeedbackContainer, FeedbackTitle } from '../styled'

// eslint-disable-next-line react/display-name
export const withRefundFormProps = WrappedComponent => props => (
  <WrappedComponent
    {...props}
    className={props.error ? 'error' : ''}
    labelFontSize="16px"
    disableBorder
  />
)

export const getFeedbackContent = (refundError, t) =>
  refundError ? (
    <React.Fragment>
      <FeedbackTitle>{t(refundError.description)}</FeedbackTitle>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <FeedbackTitle>{t('usaForms.contact-us.feedback.success-title')}</FeedbackTitle>
    </React.Fragment>
  )

export const getFormError = (formError, t, clearFormik = null) =>
  formError ? (
    <FeedbackContainer className="feedback-message">
      <Message
        e2eClass={e2eClasses('corporate.errorMessage')}
        type={'error'}
        onMessageButtonClick={() => clearFormik && clearFormik()}
        messageButtonText={t('usaForms.notification-close')}
      >
        {getFeedbackContent(formError, t)}
      </Message>
    </FeedbackContainer>
  ) : (
    <></>
  )

export const getValidateFormError = (formError, t, clearFormik = null) => {
  return formError ? (
    <FeedbackContainer className="feedback-message">
      <Message
        e2eClass={e2eClasses('corporate.errorMessage')}
        type={'error'}
        onMessageButtonClick={clearFormik}
        messageButtonText={t('usaForms.notification-close')}
      >
        {getFeedbackContent(formError, t)}
      </Message>
    </FeedbackContainer>
  ) : (
    <></>
  )
}
